export interface DeviceProfile {
  width: number;
  height: number;

  isPhone: boolean;
  isTablet: boolean;
  isDesktop: boolean;

  isPortrait: boolean;
  isLandscape: boolean;

  isTouch: boolean;

  safeTop: number;
  safeBottom: number;

  compactHeight: boolean;
}

export function createDeviceProfile(): DeviceProfile {
  const width = window.innerWidth;
  const height = window.innerHeight;

  const isPortrait = height >= width;
  const isLandscape = !isPortrait;

  const isPhone = width <= 768;
  const isTablet = width > 768 && width <= 1180;
  const isDesktop = width > 1180;

  const safeTop =
    Number(
      getComputedStyle(document.documentElement)
        .getPropertyValue("env(safe-area-inset-top)")
        .replace("px", "")
    ) || 0;

  const safeBottom =
    Number(
      getComputedStyle(document.documentElement)
        .getPropertyValue("env(safe-area-inset-bottom)")
        .replace("px", "")
    ) || 0;

  return {
    width,
    height,

    isPhone,
    isTablet,
    isDesktop,

    isPortrait,
    isLandscape,

    isTouch:
      navigator.maxTouchPoints > 0 ||
      "ontouchstart" in window,

    safeTop,
    safeBottom,

    compactHeight: height < 520,
  };
}
